
import { useEffect, useState } from 'react';

export default function AboutSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const element = document.getElementById('about-section');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <section id="about-section" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6">
        <div className={`max-w-4xl mx-auto text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-black mb-6 sm:mb-8 leading-tight">
            Más que una empresa, una{' '}
            <span className="text-yellow-500">comunidad financiera.</span>
          </h2>
          
          <div className="bg-white rounded-xl sm:rounded-2xl shadow-xl p-6 sm:p-8 lg:p-12">
            <p className="text-lg sm:text-xl lg:text-2xl text-gray-700 leading-relaxed mb-6 sm:mb-8">
              Cashflow VIP ayuda a emprendedores y empresas a alcanzar libertad financiera mediante servicios de Reestructuración de crédito, obtención de funding para LLCs, creación de corporaciones, mentorías y educación financiera en comunidad.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 mt-8 sm:mt-12">
              <div className="text-center">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="ri-trophy-fill text-black text-xl sm:text-2xl"></i>
                </div>
                <h3 className="font-bold text-base sm:text-lg text-black mb-2">Experiencia</h3>
                <p className="text-gray-600 text-sm sm:text-base">Años ayudando a empresas a crecer</p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="ri-team-fill text-black text-xl sm:text-2xl"></i>
                </div>
                <h3 className="font-bold text-base sm:text-lg text-black mb-2">Comunidad</h3>
                <p className="text-gray-600 text-sm sm:text-base">Red de emprendedores exitosos</p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="ri-rocket-fill text-black text-xl sm:text-2xl"></i>
                </div>
                <h3 className="font-bold text-base sm:text-lg text-black mb-2">Resultados</h3>
                <p className="text-gray-600 text-sm sm:text-base">Crecimiento comprobado</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
